<div class='w-full max-w-screen-xl mx-auto text-base pb-5 text-muted-foreground leading-normal px-12'>
  <div class='pt-20'>
    <h1 class='text-white font-bold text-4xl my-3'>Contact</h1>
    <p class='my-2'>If you're running into any issues with Hayase, or have an idea for an enhancement, please file an <a class='text-blue-600 dark:text-blue-500 hover:underline' href='https://github.com/hayase-app' target='_blank'>issue on github</a>.</p>
    <p class='my-2 text-xs uppercase tracking-[0.3em] text-muted-foreground/80'>Support cannot provide media, torrent links, or unofficial repositories. Please only request help with the application itself.</p>
  </div>
</div>
